export const ASSESSMENT_TOOL_URL = "https://oe-group-assessment-tool.acw-test.space";

export const CONSULTATION_URL = "https://meetings-eu1.hubspot.com/benjamin-dubach";
